import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PrimaryCardWithCollection from 'Components/ComponentLibrary/Molecules/PrimaryCardWithCollection';
import fr from 'facet-rest';

const styles = theme => ({
  root: {
    marginTop: theme.spacing(1),
  },
});

const RefinanceDebtSection = ({
  className,
  classes,
  resource,
  handleAddRefinanceDebt,
  handleModifyRefinanceDebt,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <PrimaryCardWithCollection
        title={'Refinance Debt'}
        resource={resource}
        onAdd={resource.relationship(fr.relationships.addRefinanceDebt.name) ? () => handleAddRefinanceDebt(resource) : null}
        onEdit={(res) => handleModifyRefinanceDebt(res)}
        itemCollection={resource.attr('refinanceDebtGroups')}
        getItemPrimaryText={(item) => item.attr('title')}
        getItemSecondaryText={(item) => (
          <>
            {item.attr('middleText')}
            <br />
            {item.attr('bottomText')}
          </>
        )}
        emptyListAlertTitle={'No Refinance Debt Groups'}
      />
    </Box>
  );
};

RefinanceDebtSection.defaultProps = {
  className: '',
};

RefinanceDebtSection.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  handleAddRefinanceDebt: PropTypes.func.isRequired,
  handleModifyRefinanceDebt: PropTypes.func.isRequired,
};

export default withStyles(styles)(RefinanceDebtSection);
